<template>
  <Content class="pro-content services">
    <img src="../../assets/sherbimet21_9.jpg" loading="lazy" />
    <Card class="wrapper" dis-hover>
      <h1 slot="title" class="info_title">{{ $t("services") }}</h1>
      <Row>
        <i-col :md="{ span: 7 }">
          <Card :title="$t('loans')" icon="md-cash" dis-hover class="types-card">
            <Menu :theme="'light'" width="auto" style="border: unset" :active-name="$route.path">
              <MenuGroup :title="$t('individual')">
                <MenuItem name="/services/individual/cash" to="/services/individual/cash">
                  <Icon type="ios-cash-outline" :size="20" />
                  {{ $t("cash_loan.menu_title") }}
                </MenuItem>
                <MenuItem name="/services/individual/renovation" to="/services/individual/renovation">
                  <Icon type="ios-home-outline" :size="20" />
                  {{ $t("renovation_loan.menu_title") }}
                </MenuItem>
                <MenuItem name="/services/individual/cars" to="/services/individual/cars">
                  <Icon type="ios-car-outline" :size="20" />
                  {{ $t("car_loan.menu_title") }}
                </MenuItem>
                <MenuItem name="/services/individual/mortgage" to="/services/individual/mortgage">
                  <Icon type="ios-card-outline" :size="20" />
                  {{ $t("mortgage_loan.menu_title") }}
                </MenuItem>
                <MenuItem name="/services/individual/other" to="/services/individual/other">
                  <Icon type="ios-apps-outline" :size="20" />
                  {{ $t("other_loans.menu_title") }}
                </MenuItem>
              </MenuGroup>
              <MenuGroup :title="$t('business')">
                <MenuItem name="/services/business/goods-financing" to="/services/business/goods-financing">
                  <Icon type="ios-water-outline" />
                  {{ $t("goods_financing.menu_title") }}
                </MenuItem>
                <MenuItem name="/services/business/assets-financing" to="/services/business/assets-financing">
                  <Icon type="ios-stats-outline" />
                  {{ $t("assets_financing.menu_title") }}
                </MenuItem>
                <MenuItem name="/services/business/mortgage-financing" to="/services/business/mortgage-financing">
                  <Icon type="logo-euro" />
                  {{ $t("mortgage_financing.menu_title") }}
                </MenuItem>
                <MenuItem name="/services/business/other" to="/services/business/other">
                  <Icon type="ios-apps-outline" :size="20" />
                  {{ $t("other_finances.menu_title") }}
                </MenuItem>
              </MenuGroup>
              <MenuGroup :title="$t('list_of_documents')">
                <MenuItem name="/services/documents/individual" to="/services/documents/individual">
                  <Icon type="ios-document-outline" :size="20" />{{ $t("individual_loan_docs") }}
                </MenuItem>
                <MenuItem name="/services/documents/business" to="/services/documents/business">
                  <Icon type="ios-document-outline" :size="20" />{{ $t("business_loan_docs") }}
                </MenuItem>
                <MenuItem name="/services/documents/individual-business" to="/services/documents/individual-business">
                  <Icon type="ios-document-outline" :size="20" />{{ $t("individual_business_loan_docs") }}
                </MenuItem>
              </MenuGroup>
            </Menu>
          </Card>
        </i-col>
        <i-col :md="{ span: 16, offset: 1 }" class="services-info" style="min-height: 50vh;" id="services-info">
          <router-view v-if="$route.fullPath !== '/services'"></router-view>
          <div v-if="$route.fullPath === '/services'">
            <h3>{{ $t("all_services.title") }}</h3>
            <br />
            <p>{{ $t("all_services.description") }}</p>
          </div>
        </i-col>
      </Row>
    </Card>
  </Content>
</template>
<script>
export default {
  methods: {
    scrollIntoView() {
      const container = this.$el.querySelector('#services-info');
      container.scrollIntoView({ behavior: 'smooth' });
    },
  },
  watch: {
    $route() {
      this.scrollIntoView();
    },
  },
  mounted() {
    if (this.$router.currentRoute.path !== '/services') {
      this.scrollIntoView();
    }
  },
};
</script>
<style lang="scss">
.pro-content.services {
  img {
    margin: 20px 0;
    height: inherit;
    width: inherit;
  }
  .ivu-menu-vertical::after {
    display: none;
  }
}
.services-info {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}
</style>
